import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
	UntypedFormArray,
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
} from '@angular/forms';
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';

import { Subject } from 'rxjs';

import {
	OrgBeneficiaryPendenciesRequest,
	OrgBeneficiaryPendencyItem,
} from '../../../../sanus/organizations/models/beneficiaries.model';
import { ErrorDialogComponent } from '../../../../shared/components/error-dialog/error-dialog.component';
import { AuthenticationsService } from '../../../authentications/authentications.service';
import { BeneficiariesService } from '../../beneficiaries.service';
import { BeneficiaryStatusFilter } from '../../enums/beneficiary-status-filter.enum';
import { BeneficiaryPendency } from '../../enums/pendency.enum';

@Component({
	selector: 'app-pendencies-modal',
	styleUrls: ['./pendencies-modal.component.scss'],
	templateUrl: './pendencies-modal.component.html',
})
export class PendenciesModalComponent implements OnInit, OnDestroy {
	alertMessages = [
		{ id: 'name', msg: 'Nome' },
		{ id: 'birthday', msg: 'Data de nascimento' },
		{ id: 'motherName', msg: 'Nome da mãe' },
		{ id: 'gender', msg: 'Gênero' },
		{ id: 'marital', msg: 'Estado civil' },
		{ id: 'email', msg: 'Email' },
		{ id: 'cpf', msg: 'CPF' },
		{ id: 'phone', msg: 'Telefone' },
		{ id: 'admission_date', msg: 'Data de admissão' },
		{ id: 'plan_inclusion_date', msg: 'Data de inclusão' },
		{ id: 'registration', msg: 'Registro' },
		{ id: 'position_id', msg: 'Cargo' },
		{ id: 'postal_code', msg: 'CEP' },
		{ id: 'street', msg: 'Logradouro' },
		{ id: 'number', msg: 'Número' },
		{ id: 'neighborhood', msg: 'Bairro' },
		{ id: 'state', msg: 'Estado' },
		{ id: 'city', msg: 'Cidade' },
		{ id: 'policyHealth', msg: 'Política de saúde' },
		{ id: 'policyDental', msg: 'Política dental' },
		{ id: 'benefitHealth', msg: 'Benefício de saúde' },
		{ id: 'benefitDental', msg: 'Benefício dental' },
		{ id: 'numberBenefitHealth', msg: 'Carteirinha (saúde)' },
		{ id: 'numberBenefitDental', msg: 'Carteirinha (dental)' },
	];

	authenticatedUser?: string;
	editMode = false;
	editingPendencies: OrgBeneficiaryPendencyItem[] = [];
	form!: UntypedFormGroup;
	inputId: string = String(Math.random());
	isLoading: boolean = false;
	messages: { pendency: string[]; to: string }[] = [];
	pendenciesStatus = [
		{ id: 'FIELDS_REQUIRED', disabled: true, label: 'Em aberto' },
		{ id: 'PROCESSING_IN_CARRIER', disabled: false, label: 'Em processamento' },
		{ id: 'PENDENCY_WITH_HR', disabled: false, label: 'Pendência RH' },
	];

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly fb: UntypedFormBuilder,
		public dialogRef: MatDialogRef<PendenciesModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			beneficiaryId: string;
			sanusMode: boolean;
			status: BeneficiaryStatusFilter;
		},
		private readonly beneficiariesService: BeneficiariesService,
		public legacyDialog: MatDialog,
		public dialog: MatDialog,
		private readonly authenticationsService: AuthenticationsService,
	) {
		this.pendenciesStatus.filter(
			(item) => item.id === BeneficiaryPendency.FIELDS_REQUIRED,
		)[0].disabled = data.status !== BeneficiaryStatusFilter.EXCLUSION;
		this.authenticatedUser = this.authenticationsService.getSession()?.user_id;
	}

	get items() {
		return this.form.controls.items as UntypedFormArray;
	}

	addPendencyItem(): void {
		this.items.push(
			this.fb.group({
				id: [null],
				beneficiaryId: [this.data.beneficiaryId],
				isComplete: [false],
				name: ['', [Validators.required, Validators.minLength(1)]],
			}),
		);
	}

	alertMessage(id: string): string {
		return this.alertMessages.find((message) => message.id === id)?.msg ?? '';
	}

	clearModal(): void {
		this.editingPendencies = [];
		this.messages = [];
		this.form = this.fb.group({
			items: this.fb.array([]),
			pendency: [null, Validators.required],
		});
	}

	closeModal(): void {
		this.clearModal();
		this.dialogRef.close(true);
	}

	disableWithRhRule(): boolean {
		if (
			this.form.controls.pendency.value === BeneficiaryPendency.PENDENCY_WITH_HR
		) {
			const items = this.form.controls.items.value;

			if (!items.length) {
				return true;
			}
		}

		return false;
	}

	getPendencies(): void {
		this.isLoading = true;
		this.form = this.fb.group({
			items: this.fb.array([]),
			pendency: [null, Validators.required],
		});

		this.beneficiariesService
			.getPendencies(this.data.beneficiaryId)
			.subscribe((response) => {
				if (response.pendency) {
					if (
						this.data.status === BeneficiaryStatusFilter.EXCLUSION &&
						response.pendency === BeneficiaryPendency.TO_BE_INACTIVATED
					) {
						this.form.patchValue({
							pendency: BeneficiaryPendency.FIELDS_REQUIRED,
						});
					} else {
						this.form.patchValue({
							pendency: response.pendency,
						});
					}

					for (const pendencyOperator of response.pendencyOperator) {
						this.items.push(
							this.fb.group({
								id: [pendencyOperator.id],
								beneficiaryId: [pendencyOperator.beneficiaryId],
								isComplete: [pendencyOperator.isComplete],
								name: [
									{ disabled: true, value: pendencyOperator.name },
									[Validators.required, Validators.minLength(1)],
								],
							}),
						);
						this.editingPendencies.push(pendencyOperator);
					}
					this.messages = response.pendencyBeneficiary;
					this.editMode = true;
					this.isLoading = false;
				}
			});
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	ngOnInit(): void {
		this.getPendencies();
	}

	onError(title: string, message: string): void {
		this.dialog.open(ErrorDialogComponent, {
			data: {
				canRetry: false,
				errorMessage: message,
				title: title,
			},
			maxHeight: undefined,
			maxWidth: undefined,
		});
	}

	onStatusChange(evt: MatSelectChange): void {
		this.form.get('pendency')?.setValue(evt.value);
	}

	removePendencyItem(item: OrgBeneficiaryPendencyItem, idx: number): void {
		if (this.editMode && item.id) {
			this.isLoading = true;

			const query = {
				data: {
					beneficiaryPendency: {
						update: {
							data: {
								deletedAt: new Date(),
								deletedBy: this.authenticatedUser,
							},
							where: {
								id: item.id,
							},
						},
					},
				},
				where: {
					id: this.data.beneficiaryId,
				},
			};

			this.beneficiariesService
				.deleteDependency({ beneficiaryId: this.data.beneficiaryId, query })
				.subscribe({
					error: (error) => {
						this.onError(
							'Excluir pendência',
							error.error.message || 'Ocorreu um erro ao excluir a pendência',
						);
						this.isLoading = false;
					},
					next: () => {
						this.getPendencies();
					},
				});
		} else {
			this.items.removeAt(idx);
		}
	}

	saveChanges(): void {
		const formValues: OrgBeneficiaryPendenciesRequest = this.form.getRawValue();
		let pendency;

		if (
			this.data.status === BeneficiaryStatusFilter.EXCLUSION &&
			formValues.pendency === BeneficiaryPendency.FIELDS_REQUIRED
		) {
			pendency = BeneficiaryPendency.TO_BE_INACTIVATED;
		} else {
			pendency = formValues.pendency;
		}

		if (this.editMode) {
			const newPendencies = formValues.items.filter((item) => !item.id);
			const updatedPendencies = formValues.items.filter((item) => {
				const originalPendency = this.editingPendencies.find(
					(pendency) => pendency.id === item.id,
				);

				if (!originalPendency) return false;

				return (
					item.name !== originalPendency.name ||
					item.isComplete !== originalPendency.isComplete
				);
			});

			let query: any = {
				data: {
					pendency,
				},
				where: {
					id: this.data.beneficiaryId,
				},
			};

			if (newPendencies.length) {
				query.data = {
					...query.data,
					beneficiaryPendency: {
						create: newPendencies.map((item) => {
							return {
								createdBy: this.authenticatedUser,
								name: item.name,
							};
						}),
					},
				};
			}

			if (updatedPendencies.length) {
				query.data.beneficiaryPendency = query.data.beneficiaryPendency = {
					...query.data.beneficiaryPendency,
					update: updatedPendencies.map((item) => {
						return {
							data: {
								isComplete: item.isComplete,
								name: item.name,
								updatedBy: this.authenticatedUser,
							},
							where: {
								id: item.id,
							},
						};
					}),
				};
			}

			this.beneficiariesService
				.patchPendencies({
					beneficiaryId: this.data.beneficiaryId,
					query,
				})
				.subscribe({
					error: (error) => {
						this.isLoading = false;
						this.onError(
							'Atualizar pendências',
							error.error.message ||
								'Ocorreu um erro ao atualizar as pendências',
						);
					},
					next: () => {
						this.getPendencies();
						this.closeModal();
					},
				});
		}
	}

	shouldDisableAddPendency(): boolean {
		return (
			this.form.controls.pendency.value !== BeneficiaryPendency.PENDENCY_WITH_HR
		);
	}
}
